import { render, staticRenderFns } from "./AddOrEditTreatmentProjectInfo.vue?vue&type=template&id=422adcde&scoped=true"
import script from "./AddOrEditTreatmentProjectInfo.vue?vue&type=script&lang=js"
export * from "./AddOrEditTreatmentProjectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422adcde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('422adcde')) {
      api.createRecord('422adcde', component.options)
    } else {
      api.reload('422adcde', component.options)
    }
    module.hot.accept("./AddOrEditTreatmentProjectInfo.vue?vue&type=template&id=422adcde&scoped=true", function () {
      api.rerender('422adcde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/treatment/project/sub/AddOrEditTreatmentProjectInfo.vue"
export default component.exports